import { DomainChange } from './DomainChange';

export class DomainStore {
    private version = 0;
    private versionListeners = new Set<() => void>();
    private changesetListeners = new Set<(changes: DomainChange[]) => void>();

    /** Called by the ChangeTracker after a successful flush. */
    notify(changeset: DomainChange[]): void {
        if (changeset.length === 0) {
            return;
        }
        this.version++;
        // Adapters first so engine has time to update before React reads.
        // Each listener is isolated: the mutation has already committed,
        // so one faulty subscriber must not starve the others or break
        // the flushing command. Failures surface via console.error
        // (which reaches telemetry), never silently.
        this.changesetListeners.forEach((fn) => {
            try {
                fn(changeset);
            } catch (error) {
                console.error('DomainStore changeset listener failed:', error);
            }
        });
        this.versionListeners.forEach((fn) => {
            try {
                fn();
            } catch (error) {
                console.error('DomainStore version listener failed:', error);
            }
        });
    }

    /** For useSyncExternalStore. */
    subscribe = (listener: () => void): (() => void) => {
        this.versionListeners.add(listener);
        return () => {
            this.versionListeners.delete(listener);
        };
    };

    getVersion = (): number => this.version;

    /** For engine, persistence, and Recoil bridge. */
    onChangeset(listener: (changes: DomainChange[]) => void): () => void {
        this.changesetListeners.add(listener);
        return () => {
            this.changesetListeners.delete(listener);
        };
    }
}
